import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './jsx/admin/App.jsx';

export const BASENAME = '/admin';
export const AREA = 'admin';

const container = document.getElementById("app");
const root = createRoot(container);

root.render( 
    <App />
);

const loader = document.getElementById('global-loader');
if (loader) {
  loader.style.display = 'none';
}
